<!--
 * @Author: cyl
 * @Date: 2022-09-05 16:10:23
 * @LastEditors: cyl
 * @LastEditTime: 2022-09-05 16:17:53
 * @Description: 
-->

<template>
  <svg class="svg-icon" aria-hidden="true" :width="width" :height="height">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
import "@/assets/fonts/iconfonts/index.js";
export default {
  name: "icon-svg",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    iconName() {
      return `#${this.iconClass}`;
    },
  },
};
</script>

<style>
.svg-icon {
  /* width: 1em;
  height: 1em;
  vertical-align: -0.15em; */
  fill: currentColor;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
